// extracted by mini-css-extract-plugin
export default {"cls1":"Page-cls1_dk0","cls2":"Page-cls2_MWM Page-cls1_dk0"};